import Video from '../components/video/video'

function ShowVideo(props) {
    return <Video id={props.route.id} show={true}>
        {props.children}
    </Video>
}
  
export default ShowVideo